import { Pipe, PipeTransform } from '@angular/core';
import { Product, ProductPrice } from '../api/contracts/product';
import { MealMenuService } from '../services/meal-menu.service';

@Pipe({
  name: 'getRelevantProductPrice',
})
export class GetRelevantProductPricePipe implements PipeTransform {
  constructor(private readonly menuService: MealMenuService) {}

  transform(product: Product): ProductPrice {
    return this.menuService.getRelevantProductPrice(product);
  }
}
